import { render, staticRenderFns } from "./RelatedEventNav.vue?vue&type=template&id=b8087362&scoped=true"
import script from "./RelatedEventNav.vue?vue&type=script&lang=js"
export * from "./RelatedEventNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8087362",
  null
  
)

export default component.exports